<template>
	<div
		class="am-promote"
		:class="{
			'is-playing': playing,
			'is-idle': !init
		}"
	>
		<div class="am-promote__video" :style="{ backgroundImage: `url(${thumbnail})` }">
			<div class="am-promote__container">
				<transition name="video">
					<div class="am-promote__player" v-if="playing">
						<iframe class="am-promote__embed" :src="`https://www.youtube.com/embed/${video}?autoplay=1`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
					</div>
				</transition>

				<am-button-icon
					class="am-promote__close"
					name="close"
					@click="onPause"
				/>

				<am-button
					class="am-promote__button"
					icon="play-o"
					@click="onPlay"
				>
					Assista o Vídeo
				</am-button>
			</div>
		</div>

		<div class="am-promote__book">
			<div class="am-promote__container">
				<am-text class="am-promote__subtitle" type="subtitle">
					Baixe o nosso<br /> Book Digital
				</am-text>

				<am-button
					class="am-promote__button"
					icon="book"
					@click="onBookClick"
				>
					Clique Aqui
				</am-button>

				<img class="am-promote__image" src="/images/book.png" alt="Book Digital">
			</div>
		</div>
	</div>
</template>

<script>
import AMText from '@/components/atoms/AMText'
import AMButton from '@/components/molecules/AMButton'
import AMButtonIcon from '@/components/molecules/AMButtonIcon'
import { TweenMax, Power2 } from 'gsap/TweenMax'

export default {
	components: {
		'am-text': AMText,
		'am-button': AMButton,
		'am-button-icon': AMButtonIcon,
	},

	props: {
		thumbnail: {
			type: String,
			default: ''
		},
		video: {
			type: String,
			default: 'qsbIJRoocVA'
		},
		book: {
			type: String,
			default: ''
		},
		init: {
			type: Boolean,
			default: true
		}
	},

	data: () => ({
		playing: false
	}),

	mounted() {
		if (this.init)
			this.start()
	},

	watch: {
		init(value) {
			if (value)
				this.start()
			else
				this.onPause()
		}
	},

	methods: {
		start() {
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-promote__video'), 1.5, {
				y: '-20%',
				opacity: 0,
				ease: Power2.easeOut
			})

			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-promote__book'), 1.5, {
				y: '20%',
				opacity: 0,
				ease: Power2.easeOut
			})
		},

		onPlay() {
			this.playing = true
		},

		onPause() {
			this.playing = false
		},

		onBookClick() {
			window.open(this.book, '_blank')
		}
	}
}
</script>

<style lang="scss">
.am-promote{
	min-height: 300px;
	position: relative;
	transition: .3s $easeInOutQuad;
	&__video,
	&__book{
		display: flex;
		position: absolute;
		width: 100%;
		height: 50%;
		left: 0;
		overflow: hidden;
		box-sizing: border-box;
	}
	&__close{
		position: absolute;
		top: 24px;
		right: 24px;
		visibility: hidden;
		opacity: 0;
		transition: .3s $easeInOutQuad;
	}
	&__video{
		top: 0;
		align-items: center;
		justify-content: center;
		z-index: 5;
		transition: height .4s $easeInOutQuad;
		background-color: black;
		background-size: cover;
		background-position: center;
		&:after{
			content: "";
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			z-index: -1;
			transition: .4s $easeInOutQuad .3s;
			background: linear-gradient(
				to top,
				rgba(transparent, 0), 10%,
				rgba(#F5F5F5, .8) 75%,
				rgba(#f8f8f8, 1) 100%
			);
		}
	}
	&__player{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: -2;
	}
	&__embed{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	&__book{
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		bottom: 0;
		box-sizing: border-box;
		background: #eaeaea;
		z-index: 5;
		transition: height .4s $easeInOutQuad;
	}
	&__subtitle{
		margin-bottom: 24px;
	}
	&__image{
		position: absolute;
		bottom: 0;
		right: 0;
		width: 100%;
		transform: translate(20%, 0);
		z-index: -1;
	}

	&.is-idle{
		opacity: 0;
	}

	&.is-playing{
		.am-promote{
			&__close{
				opacity: 1;
				visibility: visible;
			}
			&__video{
				height: 100%;
				&:after{
					opacity: 0;
				}
				.am-promote{
					&__button{
						opacity: 0;
						visibility: hidden;
					}
				}
			}
			&__book{
				height: 0%;
			}
			&__player{
				transform: scale(1);
			}
		}
	}

	@include grid-media($desktop-grid) {
		&__video{
			align-items: center;
			justify-content: inherit;
			&:after{
				background: linear-gradient(
					to right,
					rgba(transparent, 0), 20%,
					rgba(#F5F5F5, .8) 75%,
					rgba(#f8f8f8, 1) 100%
				);
			}
		}
		&__book{
		}
		&__subtitle{
			text-align: right;
			margin-right: 24px;
		}
		&__button{
			margin-right: 24px;
		}
		&__container{
			width: 100%;
			display: flex;
			flex-flow: column;
			align-items: flex-end;
			@include outer-container;
		}
		&__image{
			right: inherit;
			left: 0;
			transform: translate(-25%, 0);
		}
	}
}
</style>
